import axios from 'axios'
import { ElMessage } from 'element-plus'
import _ from 'lodash'
import router from '@/router/index'

function _message(msg) {
  ElMessage({
    type: 'error',
    message: msg,
  })
}

const debounceMessage = _.debounce(_message, 500)

const server = axios.create({})
server.defaults.baseURL = '/api'

// 不需要用户信息的路由白名单
const whiteList = ['/login', '/home', '/openapi', '/openapi/detail', '/openapi/version']

// request拦截器
server.interceptors.request.use(
  config => {
    // 当前选中项目存在时
    // if (router.app.$route.query.projectKey) {
    //   const headers = Object.assign({}, config.headers, {
    //     'Faas-Header': `projectKey=${router.app.$route.query.projectKey}`
    //   })
    //   config.headers = headers
    //   return config
    // }
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response拦截器
server.interceptors.response.use(
  // 请求成功  200
  response => {
    const { rawData } = response.config;
    // 返回原始data rawData
    if (rawData) {
      return response.data;
    }
    let { code, data, message } = response.data
    if (code == 404) {
      router.push({
        name: '404'
      })
    }
    // 输入校验
    if (code === 2) {
      return {
        error: true,
        message,
      }
    }

    if (code !== 0) {
      if (response.data.message) {
        debounceMessage(response.data.message)
      }
      // 异常返回
      return Promise.reject(response.data)
    }

    return data

  },
  // 请求失败（服务器端错误）
  error => {
    if (error.response.status == 401) {
      console.log('@ ~ router.currentRoute.value.path:', router.currentRoute.value.path)
      const isWhiteList = whiteList.find((item) => router.currentRoute.value.path.match(item)) || router.currentRoute.value.path === '/'

      if (!isWhiteList) {
        // debounceMessage('请重新登录')
        window.open(`${location.origin}/#/login`, '_self')
        return Promise.reject({
          status: 401
        })
      }
    }

    if (error.response.status == 403) {
      router.push({
        name: 'UserNotPermission'
      })
      return Promise.reject({
        status: 403
      })
    }

    // 其他服务器错误
    return Promise.reject({
      status: error.response.status,
      data: error.response.data
    })
  }
)



export default server
